'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _inputSelect = require('./input-select.scss');

var _inputSelect2 = _interopRequireDefault(_inputSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InputSelect = function (_React$Component) {
    _inherits(InputSelect, _React$Component);

    function InputSelect(props) {
        _classCallCheck(this, InputSelect);

        return _possibleConstructorReturn(this, (InputSelect.__proto__ || Object.getPrototypeOf(InputSelect)).call(this, props));
    }

    _createClass(InputSelect, [{
        key: 'render',
        value: function render() {
            var inputClasses = _inputSelect2.default["input-select"];

            if (this.props.disabled) {
                inputClasses += ' ' + _inputSelect2.default.disabled;
            }

            if (this.props.error) {
                inputClasses += ' ' + _inputSelect2.default.error;
            }

            return _react2.default.createElement(
                'label',
                { className: inputClasses },
                _react2.default.createElement(
                    'span',
                    { className: _inputSelect2.default.label },
                    this.props.label
                ),
                _react2.default.createElement(
                    'span',
                    { className: _inputSelect2.default["select-wrapper"] },
                    _react2.default.createElement(
                        'select',
                        {
                            onChange: this.props.onChange,
                            disabled: this.props.disabled,
                            value: this.props.value },
                        _react2.default.createElement(
                            'option',
                            { disabled: true, value: '-1' },
                            this.props.pleaseChoose
                        ),
                        this.props.options.map(function (option) {
                            return _react2.default.createElement(
                                'option',
                                { key: option.key,
                                    value: option.key },
                                option.label
                            );
                        })
                    )
                ),
                _react2.default.createElement(
                    'span',
                    { className: _inputSelect2.default["error-message"] },
                    this.props.error ? this.props.error.message : ''
                )
            );
        }
    }]);

    return InputSelect;
}(_react2.default.Component);

InputSelect.propTypes = {
    name: _propTypes2.default.string,
    id: _propTypes2.default.string,
    label: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    disabled: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
    options: _propTypes2.default.array,
    error: _propTypes2.default.object,
    value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    pleaseChoose: _propTypes2.default.string.isRequired
};

InputSelect.defaultProps = {
    disabled: false
};

exports.default = InputSelect;


//////////////////
// WEBPACK FOOTER
// ./client/components/input-select/index.js
// module id = 186
// module chunks = 0